import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import {
  fetchExternalClientDetails,
  checkIsWBSEValid
} from "../../../redux/fui/index";
import { Grid, FormControlLabel, Radio, DialogActions } from "@material-ui/core";
import {
  StyledTooltip,
  TextHelperWrapper,
  TextHelperTypography,
  StyledRadioGroup,
  TopRadioWrapper,
  ConfigurationFormLabel,
} from "../FuiStyles";
import {
  longTextEndDate,
  rootExistedHint,
  rootWrongFormatHint,
  quickConfigurationTextHelperPlainInstance,
} from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent, DateTextFieldCommonComponentv2 } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import {
  checkServiceNowTicket,
  checkRITM,
  checkOpportunityID,
  checkWBSECode,
  checkDailyDataVolume,
  checkConcurrentUsers,
  checkBenefitsExpected,
  checkPOCname,
  checkEmailFormat,
  createMaxDate
} from "./CommonFunctions";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import GeneralForm from "./GeneralForm";
import * as fuiRedux from "../../../redux/fui/index";
import { CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";
import ValidationDialog from './ValidationDialog';
import useFormValidationWithBorders from './useFormValidationWithBorders';

const aSelectedInstanceFields = {
  DMSId: { type: "string", fieldName: "dmsId" },
  ClientName: { type: "string", fieldName: "clientName" },
  DeployRegion: { type: "object", fieldName: "deployRegion" },
  SAPContractID: { type: "object", fieldName: "sapContractId" },
  AaamPlatformType: { type: "object", fieldName: "aaamPlatformType" },
};

/**
 * Plain Instance Form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */
const ServiceIntegrator = ({
  values, // the value would be changed by user's input
  updateSIForm, //the function to update PIForm values which is from redux
  updateASelectedInstanceByField,
  createdBy, // user's EID
  checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
  isRootExist, // the value that show whether DomainContextRoot exist or not from redux
  setIsAllValid, // the function to check whether all validations are satisfieds
  selectedEnvironment,
  getSelectedEnvironment,
  minDate,
  maxDate,
  getServiceEndDate,
  isServiceEndDateInvalid,
  getNotesValue,
  notesValidations,
  configurationType,
  classes,
  history,
  vendorName,
  serverInstance,
  email,
  idToken,
  isExternalClientLoading,
  externalClientData,
  externalClientError,
  fetchExternalClientDetails,
  isLoading,
  formClickSubmit,
  checkIsWBSEValid,
  isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {

  const config = configurationType === "quick";
  const [env, setEnv] = useState(""); // Local state for environment

  // check whether values are valid
  const [isRITMValid, setIsRITMValid] = useState(true);
  const [ritmAPIValidation, setRITMAPIValidation] = useState(null);

  const [isOpportunityIDValid, setIsOpportunityIDValid] = useState(true);
  const [opportunityAPIValidation, setOpportunityAPIValidation] = useState(null);
  const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
  // check whether WBSECode is equal to MD & I WBSE
  const [isWBSECodeMDIValid, setIsWBSECodeMDIValid] = useState(true);
  const [isProjectNameValid, setIsProjectNameValid] = useState(true);
  const [isDailyDataVolumeValid, setIsDailyDataVolumeValid] = useState(true);

  // Enhanced validation with borders and dialog
  const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(values, isWBSEValid, selectedEnvironment);
  const [isConcurrentUsersValid, setIsConcurrentUsersValid] = useState(true);
  const [isBenefitsExpectedValid, setIsBenefitsExpectedValid] = useState(true);
  const instanceType = history.location.state.InstanceType;

  //   const [isUsersFieldValid, setUsersField] = useState(false);
  const [isNoteVisible, setNoteVisible] = useState(true);

  const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
  const [domainContextRoot, setDomainContextRoot] = useState("[__]");
  const [regionCode, setRegionCode] = useState("[__]");
  const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
  const [customURL, setCustomURL] = useState("https://[__].genwizardsd-si.accenture.com/");
  const [isPocvalid, setPocvalid] = useState(true);
  const [isPlanInputValid, setIsPlanInputValid] = useState(false);

  const [isChecked, setIsChecked] = useState(true);

  const handleContractAvailabilityChange = (event) => {
    const value = event.target.value;
    setIsChecked(value === "yes");
    // updateSIForm("IsContractIdAvailable", value);
    if (value === "no") {
      updateSIForm("IsContractIdAvailable", "no");
      updateSIForm("SAPContractID", "0000000000");
      updateSIForm("EndToEndUId", "");
      updateSIForm("ContractAvailabilityDate", createMaxDate(14));
      setSapContractCodeLength(10)
      setPocvalid(false);
    } else {
      setPocvalid(true);
      updateSIForm("SAPContractID", "")
      updateSIForm("ClientName", "")
      updateSIForm("EndToEndUId", "")
      setSapContractCodeLength(0)
    }
  };


  useEffect(() => {
    updateASelectedInstanceByField({
      field: "aaamPlatformType",
      value: {
        Value: "myWizard AiOps Service Integrator",
      },
    });
  }, []);

  useEffect(() => {
    if (config) {
      setDomainContextRoot("[__]");
      setRegionCode("[__]");
    }
  }, [config]);

  if (config) {
    //updateSIForm("ClientName", "")
    updateSIForm("EndToEndUId", "")
    updateSIForm("Company", "")
    updateSIForm("AvanadeCountry", "")
    updateSIForm("AccentureCountry", "")
    updateSIForm("ContractAvailabilityDate", "")
  }

  if (!config) {
    if (externalClientData.length > 0) {
      updateSIForm("ClientName", externalClientData[0])
      updateSIForm("EndToEndUId", externalClientData[1])
      if (externalClientData[2] !== undefined)
        updateSIForm("Company", externalClientData[2])
      if (externalClientData[3] !== undefined)
        updateSIForm("AvanadeCountry", externalClientData[3])
      if (externalClientData[4] !== undefined)
        updateSIForm("AccentureCountry", externalClientData[4])
      if (isChecked && externalClientData[5] !== undefined) {
        if (values.GDPR === 'no')
          updateSIForm("GDPR", externalClientData[5] ? "yes" : "no")
      }
      updateSIForm("ContractAvailabilityDate", "")
      updateSIForm("IsContractIdAvailable", "yes")
    }
  }

  if (!config) {
    (isDailyDataVolumeValid &&
      isConcurrentUsersValid &&
      isBenefitsExpectedValid) &&
      !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isRITMValid && isOpportunityIDValid && isProjectNameValid && isTeamNameSelected && isPocvalid
      ? setIsAllValid(true)
      : setIsAllValid(false);
  } else {
    (isRITMValid) &&
      !isServiceEndDateInvalid && isWBSEValid && isProjectNameValid && isTeamNameSelected
      ? setIsAllValid(true)
      : setIsAllValid(false);
  }

  updateSIForm("VendorName", vendorName);
  updateSIForm("ConfigurationType", configurationType);

  // get user's input
  const handleChange = (event, fieldName) => {
    if (fieldName === "TentativeServiceEndDate" || fieldName === "ContractAvailabilityDate") {
      updateSIForm(fieldName, event);
      getServiceEndDate(event);
    } else if (fieldName === "TeamName") {
      if (event !== undefined || event !== null) {
        updateSIForm(fieldName, event);
        setIsTeamNameSelected(true);
        if (values.TeamName !== "Others") {
          updateSIForm("TeamNameOthers", "")
        }
      } else {
        setIsTeamNameSelected(false);
      }
    }
    else {
      const value = event.target.value;
      //for splunk integration
      if (fieldName === "InstanceID") {
        const tvalue = value.split("&");
        updateSIForm("InstanceId", tvalue[0]);
        updateSIForm("DomainContextRoot", tvalue[1]);
        setDomainContextRoot(tvalue[1])
        return false;
      }
      updateSIForm(fieldName, value);
      event.preventDefault();
      if (fieldName === "RITM") {
        setIsRITMValid(checkRITM(value));
      }
      if (fieldName === "OpportunityID") {
        setIsOpportunityIDValid(checkOpportunityID(value));
      }
      if (fieldName === "WBSEcode") {
        const wbsevalue = value.toUpperCase()
        const isWBSEFormatValid = checkWBSECode(wbsevalue);
        if (isWBSEFormatValid) {
          // if (wbsevalue.trim() === "CBYDQ001") {
          //   setIsWBSECodeMDIValid(false)
          // }
          checkIsWBSEValid(wbsevalue)
        }
        // setIsWBSECodeValid(checkWBSECode(value));
      }
      if (fieldName === "Pocdetails") {
        setPocvalid(checkPOCname(value));
      }
      if (fieldName === "ProjectName") {
        if (value.length > 32 || value.length < 3) {
          setIsProjectNameValid(false)
        } else {
          setIsProjectNameValid(true)
        }
      }
      if (fieldName === "DailyDataVolume") {
        if (value[0] === "0") {
          setIsDailyDataVolumeValid(false);
        } else if (parseInt(value, 10) > 200) {
          setIsDailyDataVolumeValid(false);
        } else {
          setIsDailyDataVolumeValid(checkDailyDataVolume(value));
        }
      }
      if (fieldName === "ConcurrentUsers") {
        setIsConcurrentUsersValid(checkConcurrentUsers(value));
      }
      if (fieldName === "BenefitsExpected") {
        if (value[0] === "0") {
          setIsBenefitsExpectedValid(false);
        } else {
          setIsBenefitsExpectedValid(checkBenefitsExpected(value));
        }
      }
      if (fieldName === "TentativeServiceEndDate") {
        getServiceEndDate(value);
      }
      if (fieldName === "RequestNotes") {
        if (value.length > 0 && value.length < 247) {
          getNotesValue({ emptyString: false, maxLength: false });
        } else if (value.length === 0) {
          getNotesValue({ emptyString: true, maxLength: false });
        } else if (value.length > 246) {
          getNotesValue({ emptyString: false, maxLength: true });
        }
      }
      //update aSelectedInstance as other step relies on this data
      if (aSelectedInstanceFields[fieldName]) {
        const afieldDetails = aSelectedInstanceFields[fieldName];
        afieldDetails.type === "string" &&
          updateASelectedInstanceByField({
            field: afieldDetails.fieldName,
            value,
          });
        afieldDetails.type === "object" &&
          updateASelectedInstanceByField({
            field: afieldDetails.fieldName,
            value: {
              Value: value,
            },
          });
      }

      if (fieldName === "SAPContractID") {
        let sapLength = value.length
        setSapContractCodeLength(sapLength)
        if (sapLength == 10) {
          fetchExternalClientDetails(value)
        }
      }
      if (fieldName === "GDPR" && value === "yes") {
        updateSIForm("DeploymentRegion", "");
      }
      if (fieldName === "DeploymentRegion") {
        regionHub(value);
      }
      if (fieldName === "DataClassification") {
        if (value === "Client-Production" || value === "Internal-Production") {
          setEnv("Production")
        } else if (value === "Client-NonProduction") {
          setEnv("Test")
          updateSIForm("Environment", "");
          updateSIForm("DeploymentPhase", "");
        } else if (value === "AppTeam-Development") {
          setEnv("Dev")
          updateSIForm("Tier", "")
        } else if (value === "AppTeam-Testing") {
          setEnv("Test")
          updateSIForm("Tier", "")
        } else {
          setEnv("")
          updateSIForm("Tier", "")
        }
      }
      if (fieldName === "Environment") {
        setEnv(value);
        getSelectedEnvironment(value);
      }
    }
  };

  const regionHub = (region) => {
    const alias = {
      "sydney": "dh",
      "virginia": "dh1",
      "frankfurt": "dh2",
      "singapore": "dh3",
      "tokyo": "dh4",
      "ireland": "dh5",
      "london": "dh6",
      "": "[__]"
    }
    setRegionCode(alias[region]);
    updateSIForm("DeploymentRegion", region);
  }

  getSelectedEnvironment(env);
  updateSIForm("Environment", env);
  updateSIForm("InstanceType", instanceType);

  // user can only input lower case letter and numbers in DomainContextRoot
  const handleChangeRoot = (event, fieldName) => {
    const re = /^[a-z0-9]*$/;
    const value = event.target.value;
    re.test(value) && updateSIForm(fieldName, value);
    setDomainContextRoot(value)
  };

  const handleChangeRootSuggestions = (event, value, fieldName) => {
    const re = /^[a-z0-9]*$/;
    // const value = event.target.value;
    re.test(value) && updateSIForm(fieldName, value);
    setDomainContextRoot(value)
  };

  // it would check whether the root has existed from DB once user stop typing longer than 0.3s
  const debouncedValue = useDebounce(domainContextRoot, 300);
  useEffect(() => {
    debouncedValue && checkDomainAvaliable(debouncedValue);
  }, [debouncedValue]);

  const isGDPR = values.GDPR === "yes";
  const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";

  const handleChangeMobileNo = (event, fieldName) => {
    const re = /^[0-9]{0,}$/;
    const value = event.target.value;
    re.test(value) && updateSIForm(fieldName, value);
  };
  //form validation
  const validateInputFields = (step) => {
    // Only validate on final submit (step 2) or when explicitly called with 'submit'
    if (step !== 'step2' && step !== 'submit') {
      return true; // Skip validation for intermediate steps
    }

    let ispass = true;
    const missingFields = [];

    // Collect all required fields for final validation
    let allRequiredFields = [
      'ProjectName',
      'WBSEcode',
      'SecondaryPOC',
      'DataClassification',
      'TeamName',
      'RequestNotes',
      'AdminDistributionGroup',
      'TentativeServiceEndDate'
    ];

    // Add conditional fields based on configuration
    if (!config) {
      if (isChecked) {
        allRequiredFields.push('SAPContractID');
      } else {
        allRequiredFields.push('Pocdetails', 'ClientName');
      }

      // RITM is always mandatory, OpportunityID is optional
      allRequiredFields.push('RITM', 'DeploymentPhase');
      allRequiredFields.push('UsersDistributionGroup');
    } else {
      // Quick config only requires RITM
      allRequiredFields.push('RITM');
    }

    // Add environment-specific fields
    if (values['Environment'] === "Production") {
      allRequiredFields.push('Tier');
    }

    // Add instance type-specific fields
    if (instanceType === 'Dedicated') {
      allRequiredFields.push('DomainContextRoot', 'DeploymentRegion', 'Environment');
    } else {
      allRequiredFields.push('InstanceID');
    }

    // Check each required field
    for (const fieldname of allRequiredFields) {
      let isFieldInvalid = false;

      if (fieldname === "WBSEcode" && (!values[fieldname] || values[fieldname] === "" || !isWBSEValid)) {
        isFieldInvalid = true;
        if (!values[fieldname] || values[fieldname] === "") {
          missingFields.push(fieldname); // Just field name for empty field
        } else if (!isWBSEValid) {
          missingFields.push(`${fieldname} (Invalid WBSE code)`); // Specific message for invalid code
        }
      } else if (fieldname === "RITM") {
        if (!values.RITM || values.RITM === "" || values.RITM === null) {
          isFieldInvalid = true;
          missingFields.push(fieldname);
        } else if (ritmAPIValidation === false) {
          isFieldInvalid = true;
          missingFields.push(`${fieldname} (not found in records)`);
        } else if (!isRITMValid) {
          isFieldInvalid = true;
          missingFields.push(`${fieldname} (invalid format)`);
        }
      } else if (fieldname === "OpportunityID") {
        // OpportunityID is optional, but if provided, it must be valid
        if (values.OpportunityID && values.OpportunityID !== "" && values.OpportunityID !== null) {
          if (opportunityAPIValidation === false) {
            isFieldInvalid = true;
            missingFields.push(`${fieldname} (not found in records)`);
          } else if (!isOpportunityIDValid) {
            isFieldInvalid = true;
            missingFields.push(`${fieldname} (invalid format)`);
          }
        }
      } else if (fieldname === "InstanceID" && (!values['InstanceId'] || values['InstanceId'] === "")) {
        isFieldInvalid = true;
        missingFields.push(fieldname);
      } else if (fieldname === "TentativeServiceEndDate" && (!selectedEnvironment || selectedEnvironment === "")) {
        // TentativeServiceEndDate requires environment to be selected first
        isFieldInvalid = true;
        missingFields.push(fieldname);
      } else if (fieldname === "Pocdetails") {
        if (values['Pocdetails'] === "" || !isPocvalid && values['Pocdetails'] !== "") {
          missingFields.push(fieldname);
          ispass = false;
        }
      } else if (!values[fieldname] || values[fieldname] === "") {
        isFieldInvalid = true;
        missingFields.push(fieldname);
      }

      if (isFieldInvalid) {
        ispass = false;
      }
    }

    // Use the new validation handler
    handleValidationResult(ispass, missingFields, formClickSubmit);

    return ispass;
  }

  return (
    <>
      <GeneralForm
        isPlanInputValid={isPlanInputValid}
        FormId={7}
        validateInputFields={validateInputFields}
        ClientContractFields={
          <div>
            {!config ?
              <TopRadioWrapper>
                <ConfigurationFormLabel component="legend">
                  Is a Contract ID available?
                </ConfigurationFormLabel>


                <StyledRadioGroup
                  aria-label="contract-available"
                  name="contract-available"
                  value={isChecked ? "yes" : "no"}
                  onChange={handleContractAvailabilityChange}
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio color="primary" />}
                    label="YES"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio color="primary" />}
                    label="NO"
                  />
                </StyledRadioGroup>
              </TopRadioWrapper>
              : ""}

            {(!isChecked && !config) &&
              <div style={{ fontSize: "small", color: "#0041F0" }}>
                <em>
                  To proceed with provisioning without a Contract ID, please provide the following mandatory details
                </em>
                <ul>
                  <li>WBSE Code (used for chargeback if contract is not provided)</li>
                  <li>Opportunity ID (for deal tracking and reference)</li>
                  <li>Expected Contract Availability Date (must be within 42 days)</li>
                  <li>Client Point of Contact (name and email for contract follow-up)</li>
                </ul>
              </div>
            }

            < div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >
                {(!config && isChecked) ?
                  <Grid item xs={4}>
                    {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                  </Grid>
                  : (!config && !isChecked) ?
                    <Grid item xs={4}>
                      {FormField.Pocvalid(handleChange, values, isPocvalid)}
                    </Grid>
                    : <></>
                }

                {(!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError) &&
                  <Grid item xs={4}>
                    {PlatformFormField.ClientNamePlatformField(
                      values,
                      handleChange,
                      externalClientData[0]
                    )}
                  </Grid>
                }
                {!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError && (
                    <Grid item xs={4}>
                      {PlatformFormField.EndToEndUIdPlatformField(
                        values,
                        handleChange,
                        externalClientData[1]
                      )}
                    </Grid>
                  )}
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    <StyledTooltip
                      title={longTextEndDate}
                      placement="left-start"
                      noValidate
                    >
                      <DateTextFieldCommonComponentv2
                        tentativeServiceEndDate={values.ContractAvailabilityDate}
                        minDate={0}
                        maxDate={createMaxDate(27)}
                        handleChange={handleChange}
                        idkey="ContractAvailabilityDate"
                        label="Contract Availability Date"
                      />
                    </StyledTooltip>
                  </Grid>
                }
                {(!config) &&
                  <>
                    <Grid item xs={4}>
                      <FormField.RITMField
                        values={values}
                        handleChange={handleChange}
                        isRITMValid={isRITMValid}
                        apiValidation={ritmAPIValidation}
                        setAPIValidation={setRITMAPIValidation}
                        configurationType={configurationType}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <FormField.OpportunityIDField
                        values={values}
                        handleChange={handleChange}
                        isOpportunityIDValid={isOpportunityIDValid}
                        apiValidation={opportunityAPIValidation}
                        setAPIValidation={setOpportunityAPIValidation}
                        configurationType={configurationType}
                      />
                    </Grid>
                  </>
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    {FormField.ClientNamePlatformInternal(handleChange, values)}
                  </Grid >
                }
                <Grid item xs={4}>
                  {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                </Grid>

                {config &&
                  <Grid item xs={8}>
                    <FormField.RITMField
                      values={values}
                      handleChange={handleChange}
                      isRITMValid={isRITMValid}
                      apiValidation={ritmAPIValidation}
                      setAPIValidation={setRITMAPIValidation}
                      configurationType={configurationType}
                    />
                  </Grid>}
                <Grid item xs={4}>
                  {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSEValid, isLoading)}
                </Grid >
                <Grid item xs={4}>
                  {FormField.SecondaryContact(handleChange, values, config)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.DataClassificationField(handleChange, values, configurationType)}
                </Grid>
                {!config && (
                  <Grid item xs={4}>
                    {FormField.DeploymentPhaseField(handleChange, values)}
                  </Grid>
                )}
                <Grid item xs={4}>
                  {FormField.TeamNamesField(handleChange, values, isTeamNameSelected)}
                </Grid >
                {values.TeamName === "Others" &&
                  <Grid item xs={4}>
                    {FormField.TeamNameOthers(handleChange, values)}
                  </Grid >
                }
                {
                  (config &&
                    <Grid item xs={4}>
                      {FormField.ClientNamePlatformInternal(handleChange, values)}
                    </Grid>
                  )
                }
                {/* {config &&
                <Grid item xs={4}>
                  {FormField.ClientNamePlatformInternal(handleChange, values)}
                </Grid >
              } */}


                <Grid item xs={12}>
                  {PlatformFormField.RequestNotesPlatformField(
                    values,
                    handleChange,
                    notesValidations
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        }
        EnvironmentFields={
          <div>
            <p> Expected Custom URL: <span style={{ color: " #0041F0" }}>https://{regionCode}-{domainContextRoot}.genwizardsd-si.com/</span></p>
            {instanceType === 'Dedicated' ?
              <>
                <div style={{ flexGrow: 1 }}>
                  <Grid
                    container
                    spacing={2}
                  >
                    {vendorName !== "MCC" &&
                      <Grid item xs={12}>
                        {PlatformFormField.GDPRPlatformField(
                          values,
                          handleChange,
                          isGDPR,
                          classes,
                          config,
                          isChecked,
                          externalClientData
                        )}
                      </Grid>
                    }

                    {vendorName === "MCC"
                      ? <Grid item xs={3}>
                        {PlatformFormField.DeploymentRegionPlatformMccField(
                          values,
                          handleChange
                        )}
                      </Grid>
                      : <Grid item xs={4}>
                        {PlatformFormField.DeploymentRegionPlatformField(
                          values,
                          handleChange,
                          isGDPR
                        )}
                      </Grid>
                    }

                    <Grid item xs={4}>
                      {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                        values,
                        handleChangeRootSuggestions,
                        // handleChangeRoot,
                        isRootExist,
                        rootExistedHint,
                        rootWrongFormatHint,
                        externalClientData,
                        domainContextRoot,
                        isLoading
                      ) : PlatformFormField.DomainContextRootPlatformField(
                        values,
                        handleChangeRoot,
                        isRootExist,
                        rootExistedHint,
                        isLoading
                      )}
                    </Grid>
                    {/* {!config &&
                  <Grid item xs={4}>
                    {PlatformFormField.DailyDataVolumePlatformField(
                      values,
                      handleChange,
                      isConcurrentUsersValid
                    )}
                  </Grid>
                } */}
                    {/* <Grid item xs={3}> */}
                    <Grid item xs={4}>
                      {values.DataClassification === "Client-NonProduction"
                        ? FormField.EnvironmentClientNonProdField(values, handleChange)
                        : FormField.EnvironmentField(values, handleChange, env)
                      }
                    </Grid>
                    {values.Environment === "Production" &&
                      <Grid item xs={4}>
                        {PlatformFormField.TierPlatformField2(values, handleChange)}
                      </Grid>
                    }
                  </Grid>
                </div>
              </>
              :
              <div>
                <h4 style={{ color: '#333333', fontWeight: '500' }}>Select Exisitng Splunk Server Instance</h4>
                <h4 style={{ color: '#a20000', fontWeight: '500' }}>Note: Server must be running and instance type must be greater than t2.large (cannot use same server that has Service Integrator Installed)</h4>
                <h4 id='errorInstance' style={{ color: 'blueviolet', fontWeight: '500', textAlign: 'center', display: 'none' }}>You need to select a instance!!<br />(If there is no Instance shown request a Dedicated Splunk)</h4>
                <table className="licensedata" id="InstanceID" style={{ width: '100%', textAlign: 'center', border: '1px solid #EBEBEb', fontSize: '.8rem' }}>
                  <thead>
                    <tr>
                      <th>Instance ID</th>
                      <th>Instance Type</th>
                      {/* <th>Product Name</th> */}
                      <th>Private DNS</th>
                      <th>Application URL</th>
                      <th>Cluster ID</th>
                      <th>Region</th>
                      <th>Service End Date</th>
                      {/* <th>Status</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {serverInstance.length > 0 ?
                      serverInstance.map((xitem, xindex) => {
                        if (xitem.assetname === 'Dedicated Splunk Platform' && xitem.instanceState === 'running' && xitem.instanceType !== 't2.large' && xitem.applicationname.indexOf('Service Integrator') < 0) {
                          return (
                            <tr>
                              <td><input type="radio" name="InstanceID" value={xitem.instanceId + "&" + xitem.clusterId} onClick={(e) => { handleChange(e, "InstanceID"); regionHub(xitem.regionAlias) }} />&nbsp;{xitem.instanceId}</td>
                              <td>{xitem.instanceType}</td>
                              {/* <td>{xitem.assetname}</td> */}
                              <td>{xitem.privateDNSName}</td>
                              <td>{xitem.AccessLinkURL}</td>
                              <td>{xitem.clusterId}</td>
                              <td>{xitem.regionAlias}</td>
                              <td>{xitem.serviceEndDate}</td>
                              {/* <td>{xitem.instanceState}</td> */}
                            </tr>
                          )
                        }
                      })
                      :
                      <tr style={{ borderBottom: '1px solid #EBEBEB' }}>
                        <td colSpan={6}>No Splunk Server Found</td>
                      </tr>
                    }
                  </tbody>
                </table>
                <br />
                <Grid container spacing={2}>
                  {/* <Grid item xs={4}>
                    {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                      values,
                      handleChangeRootSuggestions,
                      // handleChangeRoot,
                      isRootExist,
                      rootExistedHint,
                      rootWrongFormatHint,
                      externalClientData,
                      domainContextRoot,
                      isLoading
                    ) : PlatformFormField.DomainContextRootPlatformField(
                      values,
                      handleChangeRoot,
                      isRootExist,
                      rootExistedHint,
                      isLoading
                    )}
                  </Grid> */}
                  {values.Environment === "Production" &&
                    <Grid item xs={4}>
                      {PlatformFormField.TierPlatformField2(values, handleChange)}
                    </Grid>
                  }
                </Grid>
              </div>

            }
          </div>
        }
        ApplicationFields={
          <div style={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
            >
              <Grid item xs={6}>
                {FormField.AdminDistributionGroupField(handleChange, values)}
              </Grid>
              {!config &&
                <Grid item xs={6}>
                  {FormField.UsersDistributionGroupField(handleChange, values)}
                </Grid>
              }
              <Grid item xs={6}>
                <StyledTooltip
                  title={longTextEndDate}
                  placement="left-start"
                  noValidate
                >
                  <DateTextFieldCommonComponent
                    tentativeServiceEndDate={values.TentativeServiceEndDate}
                    selectedEnvironment={selectedEnvironment}
                    isServiceEndDateInvalid={isServiceEndDateInvalid}
                    minDate={minDate}
                    maxDate={maxDate}
                    handleChange={handleChange}
                  />
                </StyledTooltip>
              </Grid>
            </Grid>
          </div>
        }
        history={history}
      ></GeneralForm>
      {!isChecked && (
        <CommonDialogV2
          open={isNoteVisible}
          onClose={() => setNoteVisible(false)}
          title={"Note"}
          textContent={
            <div>
              <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
              <ul>
                <li>
                  Provisioned services will be automatically stopped
                </li>
                <li>
                  Cost recovery will be initiated using the provided WBSE code
                </li>
              </ul>
            </div>
          }
          dialogActions={
            <DialogActions >
              <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
            </DialogActions>
          }
        ></CommonDialogV2>
      )}
      <ValidationDialog
        open={showValidationDialog}
        onClose={closeDialog}
        errors={validationErrors}
      />
    </>
  );
};

const MSTP = (state, ownProps) => ({
  isRootExist: state.fui.isRootExist,
  values: state.fui.SIForm,
  configurationType: state.fui.configurationType,
  email: state.auth.userDetails.email,
  idToken: state.auth.idToken,
  externalClientData: state.fui.externalClientData,
  externalClientError: state.fui.externalClientError,
  isExternalClientLoading: state.fui.isExternalClientLoading,
  isLoading: state.fui.isLoading,
  isWBSEValid: state.fui.isWBSEValid,
  serverInstance: state.servers.instancesNewTags,
});

export default connect(MSTP, {
  updateSIForm: fuiRedux.updateSIForm,
  updateASelectedInstanceByField: fuiRedux.updateASelectedInstanceByField,
  checkDomainAvaliable: fuiRedux.checkRootExisted,
  fetchExternalClientDetails,
  checkIsWBSEValid
})(withRouter(ServiceIntegrator));
